module.exports = __webpack_public_path__ + "assets/media/announcer_prepare.c060b35b.mp3";